//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            searchText: ''
        }
    },
    methods: {
        showSearch() {
            this.$emit('search');
            this.$store.commit('hideIsTab');
        },
        onSearch() {
            this.$router.push({
                name: 'search',
                params: {
                    keyworld: this.searchText
                }
            });
        },
        sao() {
            this.$wechat.scanQRCode({
                needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function(res) {
                    var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                },
                complete: function(res) {}
            });
        }
    },
    props: ['title'],
    computed: {
        homeScrollTop() {
            return this.$store.state.homeScrollTop;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/Head.vue